var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "wrap-tooltip",
        on: {
          mouseleave: function($event) {
            _vm.isShowPopup = false
          }
        }
      },
      [
        _c("img", {
          attrs: { src: require("@/assets/icon/help.png"), alt: "type-help" },
          on: {
            click: function($event) {
              _vm.isShowPopup = true
            },
            mouseover: function($event) {
              _vm.isShowPopup = true
            }
          }
        }),
        _vm._v(" "),
        _vm.isShowPopup
          ? _c("div", { staticClass: "tooltip-popup" }, [
              _c("p", { staticClass: "description" }, [
                _vm._v(_vm._s(_vm.description))
              ])
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-150a4afc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-150a4afc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tooltip/jTooltipHint.vue
// module id = null
// module chunks = 